<template>
  <div>
    <b-row>

      <b-col md="12" class="d-flex align-items-center justify-content-between mb-1">
        <span class="text-muted" style="font-size:0.78rem;">Los campos con * son obligatorios</span>
        <b-link v-if="item && viewEdit" href="javascript:void(0);" class="small" @click="openFullEdit()">
          <b-icon icon="box-arrow-up-right" class="mr-1"></b-icon>
          Ver ficha completa
        </b-link>
      </b-col>

      <b-col md="12">
        <b-form-group label="Nombre *" label-size="sm">
          <b-form-input v-model="form.name" size="sm" placeholder="Nombre de la categoría"
                        ref="inputName" @keyup.enter.native="save()" :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Horas" label-size="sm">
          <b-form-input v-model="form.hours" type="number" size="sm" min="0" :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Salario" label-size="sm">
          <b-form-input v-model="form.salary" type="number" size="sm" min="0" :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="12" class="d-flex justify-content-end mt-1">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="$emit('cancel')" :disabled="loading">
          Cancelar
        </b-button>
        <b-button variant="primary" size="sm" @click="save()" :disabled="loading || !form.name.trim()">
          <b-icon icon="check" class="mr-1"></b-icon>
          Guardar
        </b-button>
      </b-col>

    </b-row>
  </div>
</template>
<script>
  import serviceAPI from '../services'

  const emptyForm = () => ({ name: '', hours: 0, salary: 0 })

  export default {
    props: {
      item: { type: Object, default: null },
      viewEdit: { type: String, default: '' },
      viewEditParamID: { type: String, default: '' },
    },
    data() {
      return { form: emptyForm(), loading: false }
    },
    watch: {
      item: {
        immediate: true,
        handler(val) {
          if (val) { this.loadForEdit(val.id) } else { this.form = emptyForm() }
        },
      },
    },
    mounted() {
      this.$nextTick(() => { if (this.$refs.inputName) this.$refs.inputName.focus() })
    },
    methods: {
      loadForEdit(id) {
        this.loading = true
        serviceAPI.obtenerCategoriaEmpleado(id)
          .then((r) => {
            this.form = Object.assign(emptyForm(), r.data)
            this.form.name = this.form.name || ''
            this.form.hours = this.form.hours || 0
            this.form.salary = this.form.salary || 0
          })
          .finally(() => { this.loading = false })
      },
      openFullEdit() {
        var params = {}
        params[this.viewEditParamID] = this.item.id
        window.open(this.$router.resolve({ name: this.viewEdit, params: params }).href, '_blank')
      },
      save() {
        if (!this.form.name.trim()) return
        this.loading = true
        var isEdit = this.item && this.item.id
        var data = Object.assign({}, this.form, {
          name: this.form.name.trim(),
          hours: this.form.hours,
          salary: this.form.salary,
        })
        var call = isEdit
          ? serviceAPI.editarCategoriaEmpleado(Object.assign({}, data, { id: this.item.id }))
          : serviceAPI.agregarCategoriaEmpleado(data)
        call
          .then((r) => {
            this.$awn.success(isEdit ? 'Categoría actualizada' : 'Categoría creada')
            this.$emit('saved', r.data)
          })
          .catch(() => { this.$awn.alert('Error al guardar la categoría') })
          .finally(() => { this.loading = false })
      },
    },
  }
</script>
